class DispatchCode {
  constructor(title, hasNotification) {
    this.title = title;
    this.hasNotification = hasNotification;
  }
}
export default {
  inject: ['load'],
  data() {
    return {
      allDispatchCodes: [],
      dispatchCode: new DispatchCode('', false),
      allDispatchCodesForOther: [],
    };
  },
  methods: {
    getListOfDispatchCodesForOther: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllDispatchCodes').then(() => {
        if (this.$store.state.dispatchCodeModule.successFlag) {
          this.allDispatchCodesForOther = this.$store.state.dispatchCodeModule.allDispatchCodes;
          if (this.$route.name == 'mission800' || this.$route.name == 'currentMission800') {
            // 800 edit modal
            this.allDispatchCodesForOther = this.allDispatchCodesForOther.filter(
              (c) => c.isActive == true,
            );
            this.getMissionBy800Function(this.missionPhoneId);
          }
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.dispatchCodeModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfDispatchCodesForOther();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.dispatchCodeModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getListOfDispatchCodesForOther();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getAllDispatchCodes: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllDispatchCodes').then(() => {
        if (this.$store.state.dispatchCodeModule.successFlag) {
          let temp = this.$store.state.dispatchCodeModule.allDispatchCodes;
          this.allDispatchCodes = [];
          for (let i = 0; i < temp.length; i++) {
            let isActive = true;
            if (temp[i].isActive == false) {
              isActive = false;
            }
            this.allDispatchCodes.push({
              title: temp[i].title ? temp[i].title : '-',
              notification: temp[i].hasNotification ? temp[i].hasNotification : false,
              status: isActive,
              counter: i + 1,
              id: temp[i].id,
            });
          }
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.dispatchCodeModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getAllDispatchCodes();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.dispatchCodeModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getAllDispatchCodes();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    addDispatchCodeFunction: function () {
      if (!this.dispatchCode.title) {
        this.snackText = 'عنوان کدهای 800 نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.dispatchCode.title.replace(/\s/g, '').length) {
        this.snackText = 'عنوان کدهای 800 نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('addDispatchCode', this.dispatchCode).then(() => {
        if (this.$store.state.dispatchCodeModule.successFlag) {
          this.$refs.confirm.showConfirmDialog = false;
          this.showAddEditModal = false;
          this.disabelConfirm = false;
          this.snackText = ' کدهای 800 با موفقیت اضافه شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          if (this.load.val) {
            this.load.val = false;
          }
          this.isActive = false;
          this.dispatchCode = new DispatchCode('', false);
          this.getAllDispatchCodes();
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.dispatchCodeModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.addDispatchCodeFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.dispatchCodeModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.addDispatchCodeFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getDispatchCodeFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getDispatchCode', id).then(() => {
        if (this.$store.state.dispatchCodeModule.successFlag) {
          this.dispatchCode = this.$store.state.dispatchCodeModule.dispatchCode;
          if (this.dispatchCode.isActive == false) {
            this.isActive = false;
          } else {
            this.isActive = true;
          }
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.dispatchCodeModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getDispatchCodeFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.dispatchCodeModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getDispatchCodeFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    editDispatchCodeFunction: function () {
      if (!this.dispatchCode.title) {
        this.snackText = 'عنوان کدهای 800 نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.dispatchCode.title.replace(/\s/g, '').length) {
        this.snackText = 'عنوان کدهای 800 نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      this.dispatchCode.isActive = this.isActive;
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('editDispatchCode', this.dispatchCode).then(() => {
        if (this.$store.state.dispatchCodeModule.successFlag) {
          this.$refs.confirm.showConfirmDialog = false;
          this.disabelConfirm = false;
          this.showAddEditModal = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.getAllDispatchCodes();
          this.snackText = ' کدهای 800 با موفقیت ویرایش شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          this.isActive = false;
          this.dispatchCode = new DispatchCode('', false);
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.dispatchCodeModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.editDispatchCodeFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.dispatchCodeModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.editDispatchCodeFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    deleteDispatchCodeFunction: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('deleteDispatchCode', this.dispatchCodeId).then(() => {
        if (this.$store.state.dispatchCodeModule.successFlag) {
          this.disabelConfirm = false;
          this.$refs.confirm.showConfirmDialog = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.getAllDispatchCodes();
          this.snackText = ' کدهای 800 با موفقیت حذف شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.dispatchCodeModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.deleteDispatchCodeFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.dispatchCodeModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.deleteDispatchCodeFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.dispatchCodeModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
